import { Component, Event, EventEmitter, Prop, h } from "@stencil/core";

@Component({
  tag: "av-disclaimer",
  styleUrl: "av-disclaimer.scss",
  shadow: true,
})
export class AvDisclaimer {
  @Prop() url: string;
  @Prop({ mutable: true }) accepted: boolean;

  @Event({ bubbles: false }) acceptedChange: EventEmitter<boolean>;

  render() {
    return (
      <label class="disclaimer">
        <div>
          <input
            type="checkbox"
            checked={this.accepted}
            onChange={(e) => {
              this.accepted = (e.target as HTMLInputElement).checked;
              this.acceptedChange.emit(this.accepted);
            }}
          />
        </div>
        <span>
          <av-translate>I accept the</av-translate>
          <br />
          <a href={this.url} target="_blank">
            <av-translate>terms & conditions</av-translate>
          </a>
        </span>
      </label>
    );
  }
}
